/* eslint-disable no-debugger */
import { Checkbox } from "@mui/material";
import React from "react";
import { CustomTable, CustomTableHead, CustomTableRow, CustomTableCell, CustomTableBody } from "..";
import Loader from "../../../../navigation/routes/components/Loader";
import { translate } from "../../../providers";
import { CustomButton } from "../../buttons";
import { I18nTranslate } from "../../i18n";
import { icon } from "../../icon-component";
import { UserAvatar } from "../../user-avatar";
import styles from "./UsersTable.module.css";
import { EmptyState } from "../../empties";
import { CustomTooltip } from "../../tooltip";

const getUserName = (user) =>
	user.displayName || [user.firstname || user.firstName, user.lastname || user.lastName].filter(Boolean).join(" ");

export default function UsersTable({
	checkedUsers,
	className = "",
	companyId,
	emptyStateButton,
	emptyStateText,
	isLoading,
	onCheckAll,
	onCheckUser,
	onOpenDialog,
	searchText = "",
	users,
}) {
	const hasUsers = Array.isArray(users) && !isLoading && users.length > 0;
	return (
		<div className={className}>
			<CustomTable className={styles.table}>
				{hasUsers && (
					<CustomTableHead>
						<CustomTableRow className={styles["header-row"]}>
							<CustomTableCell className={styles["check-cell"]}>
								<Checkbox
									checked={checkedUsers.length === users.length && users.length !== 0}
									className={styles.checkbox}
									color="primary"
									indeterminate={checkedUsers.length > 0 && checkedUsers.length < users.length}
									size="small"
									onChange={onCheckAll}
								/>
							</CustomTableCell>
							<CustomTableCell className={styles["header-cell"]}>
								{translate("common:components.users-table.header.members")}
							</CustomTableCell>
						</CustomTableRow>
					</CustomTableHead>
				)}
				<CustomTableBody>
					{(hasUsers &&
						users.map((user) => (
							<CustomTableRow key={user.email} className={styles.row}>
								<CustomTableCell className={styles["check-cell"]}>
									<Checkbox
										checked={checkedUsers.some((u) => u.email === user.email)}
										className={styles.checkbox}
										color="primary"
										size="small"
										onChange={() => onCheckUser(user)}
									/>
								</CustomTableCell>
								<CustomTableCell autoTranslate="no" className={styles["member-cell"]}>
									<div className={styles["member-cell__content"]}>
										<UserAvatar
											companyId={companyId}
											displayName={user.displayName}
											email={user.email}
											firstName={user.firstname || user.firstName}
											lastName={user.lastname || user.lastName}
											size="xs"
											userId={user.id}
										/>
										<div className={styles["member-cell__identity"]}>
											<CustomTooltip showWhenOverflow title={getUserName(user)}>
												<span className={styles["member-cell__name"]}>{getUserName(user)}</span>
											</CustomTooltip>
											<CustomTooltip showWhenOverflow title={user.email}>
												<span className={styles["member-cell__email"]}>{user.email}</span>
											</CustomTooltip>
										</div>
									</div>
								</CustomTableCell>
							</CustomTableRow>
						))) ||
						(searchText && !isLoading && (
							<CustomTableRow>
								<CustomTableCell align="center" className={styles["empty-row"]} colSpan={2}>
									<I18nTranslate
										className={styles["empty-row__text"]}
										param={{ searchText }}
										translationKey="common:components.users-table.empty"
									/>
									<CustomButton startIcon={icon.faPlus} variant="outlined" onClick={onOpenDialog}>
										{translate("common:components.users-table.empty.add-button")}
									</CustomButton>
								</CustomTableCell>
							</CustomTableRow>
						))}
				</CustomTableBody>
			</CustomTable>
			{!isLoading && Array.isArray(users) && users.length === 0 && !searchText && (
				<EmptyState btn1={emptyStateButton()} className={styles["empty-state"]} title={emptyStateText} />
			)}
			{isLoading && (
				<div className={styles["loader-container"]}>
					<Loader />
				</div>
			)}
		</div>
	);
}
